var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "app",
      style: { backgroundColor: _vm.mainData.index_bg_color || "#FF7163" },
      attrs: { id: "app" }
    },
    [
      _c("div", {
        staticClass: "header",
        style: { backgroundImage: "url(" + _vm.mainData.page_top_image + ")" }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "content",
          style: { backgroundColor: _vm.mainData.index_bg_color }
        },
        [
          _c("div", {
            staticClass: "guide-desc",
            domProps: { innerHTML: _vm._s(_vm.mainData.award_guide_desc) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "get-reward-content" }, [
            _vm.isAliPayMainEntry && _vm.isInAlipay
              ? _c("div", {
                  staticClass: "btn-reward",
                  class: { "btn-reward-out": true },
                  style: { backgroundColor: _vm.mainData.award_button_color },
                  domProps: {
                    innerHTML: _vm._s(_vm.mainData.award_button_text)
                  },
                  on: { click: _vm.authCodeGetReward }
                })
              : _vm._e(),
            _vm._v(" "),
            !(_vm.isInAlipay && _vm.mainData.no_verify) &&
            ((!_vm.isOuterActivity && !_vm.isInAmap) ||
              (_vm.mainData.phone_page_type === 1 && !_vm.isInAmap))
              ? _c("div", {
                  staticClass: "btn-reward",
                  class: { "btn-reward-out": true },
                  style: { backgroundColor: _vm.mainData.award_button_color },
                  domProps: {
                    innerHTML: _vm._s(_vm.mainData.award_button_text)
                  },
                  on: { click: _vm.opentel }
                })
              : _vm._e(),
            _vm._v(" "),
            (_vm.isOuterActivity &&
              _vm.mainData.phone_page_type === 2 &&
              !_vm.isInAmap &&
              !_vm.isInAlipay) ||
            (!_vm.isInAmap &&
              _vm.isInAlipay &&
              !_vm.mainData.no_verify &&
              _vm.isOuterActivity &&
              _vm.mainData.phone_page_type === 2)
              ? _c("div", { staticClass: "input_content-wrap" }, [
                  _c("div", { staticClass: "line_wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.telNum,
                          expression: "telNum"
                        }
                      ],
                      staticClass: "tel input",
                      attrs: {
                        type: "tel",
                        placeholder: "请输入手机号",
                        maxlength: 11
                      },
                      domProps: { value: _vm.telNum },
                      on: {
                        focus: function($event) {
                          return _vm.setViewArea("phone")
                        },
                        blur: _vm.temporaryRepair,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.telNum = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "line_wrap vali_wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.validNum,
                          expression: "validNum"
                        }
                      ],
                      staticClass: "vali_num input",
                      attrs: { type: "number", placeholder: "手机验证码" },
                      domProps: { value: _vm.validNum },
                      on: {
                        focus: function($event) {
                          return _vm.setViewArea("code")
                        },
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.validNum = $event.target.value
                          },
                          _vm.handleInputLength
                        ],
                        blur: _vm.temporaryRepair
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "vali_btn",
                        class: {
                          disablevali: !_vm.telStatus || !_vm.validBtnStatus
                        },
                        on: { click: _vm.getValidNum }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.validBtnText) +
                            "\n            "
                        ),
                        _vm.validBtnText !== "获取验证码"
                          ? _c("span", [_vm._v("s")])
                          : _vm._e()
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "btn-reward",
                    class: { disable: !_vm.validStatus || !this.telStatus },
                    style: {
                      backgroundColor:
                        !_vm.validStatus || !this.telStatus
                          ? "#c9c9c9"
                          : _vm.mainData.award_button_color
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.mainData.award_button_text)
                    },
                    on: { click: _vm.handleGetVoucher }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isInAlipay && _vm.mainData.no_verify
              ? _c("div", { staticClass: "input_content-wrap" }, [
                  _c("div", { staticClass: "line_wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.telNum,
                          expression: "telNum"
                        }
                      ],
                      staticClass: "tel input",
                      attrs: {
                        type: "tel",
                        placeholder: "请输入手机号",
                        maxlength: 11
                      },
                      domProps: { value: _vm.telNum },
                      on: {
                        focus: function($event) {
                          return _vm.setViewArea("phone")
                        },
                        blur: _vm.temporaryRepair,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.telNum = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "btn-reward",
                    class: { disable: !this.telStatus },
                    style: {
                      backgroundColor: !this.telStatus
                        ? "#c9c9c9"
                        : _vm.mainData.award_button_color
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.mainData.award_button_text)
                    },
                    on: { click: _vm.handleGetVoucher }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isInAmap
              ? _c("div", { staticClass: "input_content-wrap" }, [
                  _c("div", { staticClass: "line_wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.telNum,
                          expression: "telNum"
                        }
                      ],
                      staticClass: "tel input",
                      attrs: {
                        type: "tel",
                        placeholder: "请输入手机号",
                        maxlength: 11
                      },
                      domProps: { value: _vm.telNum },
                      on: {
                        blur: _vm.temporaryRepair,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.telNum = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "btn-reward",
                    class: { disable: !this.telStatus },
                    style: {
                      backgroundColor: !this.telStatus
                        ? "#c9c9c9"
                        : _vm.mainData.award_button_color
                    },
                    domProps: {
                      innerHTML: _vm._s(_vm.mainData.award_button_text)
                    },
                    on: { click: _vm.handleGetVoucher }
                  })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div"),
          _vm._v(" "),
          _vm.isAgreeState &&
          !_vm.isInAmap &&
          !_vm.isInAlipay &&
          (_vm.mainData.phone_page_type === 1 ||
            _vm.mainData.phone_page_type === 2)
            ? _c("div", { staticClass: "clause-body" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.isAgreeClause,
                      expression: "isAgreeClause"
                    }
                  ],
                  staticClass: "clause-input",
                  attrs: { type: "checkbox", id: "clauseBox" },
                  domProps: {
                    checked: Array.isArray(_vm.isAgreeClause)
                      ? _vm._i(_vm.isAgreeClause, null) > -1
                      : _vm.isAgreeClause
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.isAgreeClause,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.isAgreeClause = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.isAgreeClause = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.isAgreeClause = $$c
                        }
                      },
                      _vm.selectCheckBox
                    ]
                  }
                }),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "rule-content" }, [
            _c("div", { staticClass: "rule-title" }),
            _vm._v(" "),
            _c("div", {
              staticClass: "rule-desc",
              domProps: { innerHTML: _vm._s(_vm.mainData.rule_desc) }
            })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "logo",
            style: {
              backgroundImage: "url(" + _vm.mainData.logo + ")",
              backgroundSize: "100% 100%"
            }
          }),
          _vm._v(" "),
          !_vm.isAgreeState &&
          (_vm.mainData.phone_page_type === 1 ||
            _vm.mainData.phone_page_type === 2)
            ? _c("div", { staticClass: "clause" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "http://cache.amap.com/h5/h5/publish/241/index.html"
                    }
                  },
                  [_vm._v("高德服务条款")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("  |  ")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "http://cache.amap.com/h5/h5/publish/238/index.html"
                    }
                  },
                  [_vm._v("隐私权政策")]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.isMask
        ? _c(
            "div",
            {
              staticClass: "mask",
              attrs: { id: "weixinMask" },
              on: { click: _vm.clickEvent }
            },
            [
              _c("div", { staticClass: "arrow" }),
              _vm._v(" "),
              !_vm.isIos
                ? _c("div", { staticClass: "guard android" })
                : _vm._e(),
              _vm._v(" "),
              _vm.isIos ? _c("div", { staticClass: "guard ios" }) : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.maskShow
          ? _c("div", { ref: "modalMask", staticClass: "modal-mask" })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: _vm.noModalAnimation ? "modal" : "modal" } },
        [
          _vm.modalCommonShow
            ? _c("CommonModal", {
                attrs: { commonType: _vm.commonType },
                on: { modalHandler: _vm.modalHandler }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalValidateShow
            ? _c("ValidateModal", {
                ref: "validModel",
                attrs: { mainData: _vm.mainData, jumpAction: 21, location: {} },
                on: { modalHandler: _vm.modalHandler, rewardShow: _vm.reward }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalRewardShow
            ? _c("RewardModal", {
                attrs: {
                  mainData: _vm.mainData,
                  dataAward: _vm.dataAward,
                  mini_app: _vm.mini_app,
                  isAliPayMainEntry: _vm.isAliPayMainEntry
                },
                on: { modalHandler: _vm.modalHandler }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "clauseBox" } }, [
      _c("span", [_vm._v("我已阅读并同意")]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "http://cache.amap.com/h5/h5/publish/241/index.html" }
        },
        [_vm._v("高德地图服务条款")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("和")]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "http://cache.amap.com/h5/h5/publish/238/index.html" }
        },
        [_vm._v("隐私权政策")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }